module.exports = __webpack_public_path__ + "static/sliderTwo-cfc14d1ddffccff17bb05a2cb51d0df6.png";